"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _ButtonImage = _interopRequireDefault(require("../../molecules/ButtonImage/ButtonImage"));

var _Icon = _interopRequireDefault(require("../../atoms/Icon/Icon"));

var _Paragraph = _interopRequireDefault(require("../../atoms/Paragraph/Paragraph"));

var _theme = _interopRequireDefault(require("../../../theme/theme.styles"));

var _Header = require("./Header.styles");

var _excluded = ["type", "text", "action", "profilePic", "logo", "shadow", "dataTestId"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var baseLogo = 'https://firebasestorage.googleapis.com/v0/b/uma-v2.appspot.com/o/_assets%2FlogoUma.png?alt=media&token=8601be70-67ec-48c0-a8fb-c0917253372e';

var Header = function Header(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'back' : _ref$type,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? 'Text' : _ref$text,
      action = _ref.action,
      profilePic = _ref.profilePic,
      _ref$logo = _ref.logo,
      logo = _ref$logo === void 0 ? baseLogo : _ref$logo,
      _ref$shadow = _ref.shadow,
      shadow = _ref$shadow === void 0 ? true : _ref$shadow,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'occ-header' : _ref$dataTestId,
      props = _objectWithoutProperties(_ref, _excluded);

  var history = (0, _reactRouterDom.useHistory)();

  var handleAction = function handleAction() {
    if (type === 'back') {
      if (action) action();else history.goBack();
    }

    if (type === 'service') {
      if (action) action();else history.push("/profile");
    }

    if (type === 'backTitle') {
      if (action) action();else history.goBack();
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_theme["default"], null), /*#__PURE__*/_react["default"].createElement(_Header.Occ_Header, {
    htype: type,
    shadow: shadow,
    backgroundT: props.transparentBg,
    "data-test-id": dataTestId
  }, type === 'back' && /*#__PURE__*/_react["default"].createElement(_Header.Occ_HeaderButton, {
    htype: type,
    onClick: handleAction
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    color: "primary",
    name: "arrowBack",
    size: "sm"
  })), type === 'service' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "/"
  }, /*#__PURE__*/_react["default"].createElement(_Header.Occ_HeaderImg, {
    src: logo,
    alt: "Logo de Uma"
  })), /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], {
    text: text,
    align: "center"
  }), profilePic ? /*#__PURE__*/_react["default"].createElement(_ButtonImage["default"], {
    src: profilePic,
    action: handleAction
  }) : /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "userCircle",
    action: handleAction
  })), type === 'backTitle' && /*#__PURE__*/_react["default"].createElement(_Header.Occ_HeaderBackTitleContainer, null, /*#__PURE__*/_react["default"].createElement(_Header.Occ_HeaderButton, {
    htype: type,
    onClick: handleAction
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    color: "primary",
    name: "arrowBack",
    size: "sm"
  })), /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], {
    size: props.textSize,
    color: props.textColor,
    weight: props.textWeight,
    text: text,
    align: "center"
  }))));
};

var _default = Header;
exports["default"] = _default;